import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { message } from 'antd';
import { Redirect } from 'react-router';
import _ from 'lodash';
import moment from 'moment';
import Linkify from 'react-linkify';
import Api from '../../Util/API';

import BackerAvatarItem from './BackerAvatarItem';
import AlertLateProject from './AlertLateProject';
import ModalBack from '../Modal/ModalBack';
import ModalAlert from '../Modal/ModalAlert';
import ModalInviteBackers from '../Modal/ModalInviteBackers';
import ModalDeleteProject from '../Modal/ModalDeleteProject';
import ProjectInfos from './ProjectInfos';
import Achieve from './Achieve';
import Edit from '../Icons/Edit.svg';
import Trash from '../Icons/Trash.svg';
import BackonLogoWhite from '../Icons/BackonLogoWhite.svg';
import Loader from '../Icons/Loader';

import './Project.css';

const colorsTab = ['#86CFFF','#BFE5FF','#F8CECF','#FAE7E8','#7FADBC','#C9DFE7','#E9E5B7','#F1C28F','#E0E7CB','#D4DDA6','#C2DDA6','#BBE2C8','#BAEAEB']

class Project extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	data:[],
	    	backers:[],
	    	hasUserBacked:false,
	    	formRedirect:false,
	    	achievementRequest:false,
	    	backgroundColor: colorsTab[this.getRandomInt(13)]
	    };
	    this.displayModal = this.displayModal.bind(this);
	    this.refreshData = this.refreshData.bind(this);
	    this.getData = this.getData.bind(this);
	    this.manageNotifications = this.manageNotifications.bind(this);
	    this.getAllowedUsers = this.getAllowedUsers.bind(this);
	    this.backFormValid = this.backFormValid.bind(this);
	    this.messageInfo = this.messageInfo.bind(this);
	    this.getRandomInt = this.getRandomInt.bind(this);
	}

	componentDidMount(){
	    this.getData();
	    this.getWallet();
	    this.manageNotifications();
		window.scrollTo(0, 0);
	}

	manageNotifications(){
		Api.request('projects/private/' + this.props.currentUser.email)
				.then(projects => {
					let currentProject = _.filter(projects, {project_id: this.props.match.params.id});
					if(currentProject.length > 0){
					    if(currentProject[0].privacy === 1 && currentProject[0].has_seen_invite === 0){
					    	this.props.actions.postInviteSeen(currentProject[0].project_id);
					    }
			    		this.getBackers();
			    		this.getAllowedUsers();
					}
				});
	}

	getData() {
		Api.request('projects/' + this.props.currentUser.email)
				.then(projects => {
					let currentProject = _.filter(projects, {project_id: this.props.match.params.id});
					if(currentProject.length > 0){
						this.setState({
					    	data:currentProject[0]
					    })
					    if(currentProject[0].privacy === 1 && currentProject[0].has_seen_invite === 0){
					    	this.props.actions.postInviteSeen(currentProject[0].project_id);
					    }
			    		this.getBackers();
			    		this.getAllowedUsers();
					}
				});
	}

	getWallet(){
		this.props.actions.getWallet();
	}

	getBackers(){
		Api.request('transactions/' + this.props.match.params.id)
			.then(transactions => {
				let backers = _.reject(transactions, {amount: 0})
				this.setState({
			    	backers,
			    	current_backers:backers.length
			    })
			    this.hasUserBacked();
			});
	}

	getAllowedUsers(){
		Api.request('users/allowed/' + this.props.match.params.id)
			.then(allowedusers => {
				let allowedusers_awaiting = _.filter(allowedusers, {has_accepted_invite: 0});
				let allowedusers_accepted = _.filter(allowedusers, {has_accepted_invite: 1});
				Api.request('users')
					.then(users => {
						let AUAwa = [];
						let AUAcc = [];
						for(let i = 0; i < allowedusers_awaiting.length; i++){
							let currentUser = _.filter(users, {id: allowedusers_awaiting[i].user_id});
							AUAwa = AUAwa.concat(currentUser);
						}
						for(let i = 0; i < allowedusers_accepted.length; i++){
							let currentUser = _.filter(users, {id: allowedusers_accepted[i].user_id});
							AUAcc = AUAcc.concat(currentUser);
						}
						for(let i = 0; i < this.state.backers.length; i++){
							AUAwa = _.reject(AUAwa, {email: this.state.backers[i].email});
							AUAcc = _.reject(AUAcc, {email: this.state.backers[i].email});
						}
						AUAwa = _.reject(AUAwa, {email: this.state.data.creator_email});
						AUAcc = _.reject(AUAcc, {email: this.state.data.creator_email});
						this.setState({
					    	allowedusers_awaiting: AUAwa,
					    	allowedusers_accepted: AUAcc
					    })
					});
				
			});
	}

	hasUserBacked(){
		let hasUserBacked = _.find(this.state.backers, {email: this.props.currentUser.email});
		if(hasUserBacked !== undefined){
			this.setState({
		    	hasUserBacked:true,
		    	userBackingAmount:hasUserBacked.amount
		    })
		}else{
			this.setState({
		    	hasUserBacked:false
		    })
		}
	}

	refreshData(){
	    this.getData();
	    this.getWallet();
	}

	backFormValid(){
		this.props.actions.getProjects();
		this.refreshData();
	}

	messageInfo(value){
		message.info(value, 2);
	}

	cancelBacking(){
		this.props.actions.backingAction(this.props.match.params.id,-this.state.userBackingAmount,this.state.data.title);
	}

	displayModal(value) {
		this.props.actions.displayModal(value);
	}

	deleteProject(){
		this.props.actions.deleteProject(this.state.data);
	}

	moveProjectToCurrentYear(){
		this.props.actions.moveProjectToCurrentYear(this.state.data);
	}

	achieveProject(){
		this.setState({
	    	achievementRequest:true
	    })
	}

	cancelAchieveProject(){
		this.setState({
	    	achievementRequest:false
	    })
	}

	getRandomInt(max) {
	  return Math.floor(Math.random() * Math.floor(max));
	}

	render() {
		const createBackerAvatarItem = (item, index) => {
	    	return <BackerAvatarItem data={item} id={index} key={index} />
	    }
	    const pictureStyle = {
			backgroundColor: this.state.backgroundColor
		};
		const getProgress = () => {
			let progressValue = 100 * this.state.data.current_amount / this.state.data.target;
			return ((progressValue > 100 ? 100 : progressValue) + '%');
		}
		const areTransactionsFromCurrentYear = backers => {
			let answer = true;
			backers.map(item => {
				if(moment(item.created_at).format('YYYY') < moment().format('YYYY')){
					answer = false;
				}
				return true
			})
			return answer
		}
		return (
			<div>
				{ this.state.achievementRequest &&
					<Achieve 
						data={this.state.data} 
						backers={this.state.backers} 
						actions={this.props.actions}
						currentUser={this.props.currentUser}
						formRedirect={this.props.formRedirect}
						achieveProjectIsLoading={this.props.achieveProjectIsLoading}
						pictureStyle={pictureStyle}
						cancel={() => this.cancelAchieveProject()} />
				}
				{ this.state.data && !this.state.achievementRequest &&
					<div className="container">
						{ this.props.isModalVisible && this.props.modalVisible === 'back' &&
							<ModalBack 
								dataID={this.state.data.project_id} 
								currentUser={this.props.currentUser} 
								id={this.props.match.params.id} 
								title={this.state.data.title}
								actions={this.props.actions} 
								backingIsLoading={this.props.backingIsLoading} 
								messageInfo={() => this.messageInfo('Thank you for your donation!')} 
								backFormValid={() => this.backFormValid()} />
						}
						{ this.props.isModalVisible && this.props.modalVisible === 'alert' &&
							<ModalAlert 
								dataID={this.state.data.project_id} 
								currentUser={this.props.currentUser} 
								id={this.props.match.params.id} 
								actions={this.props.actions} 
								userBackingAmount={this.state.userBackingAmount} 
								backingIsLoading={this.props.backingIsLoading} 
								messageInfo={() => this.messageInfo('Backing cancelled')} 
								cancelBacking={() => this.cancelBacking()} 
								type="cancelBacking" 
								backFormValid={() => this.backFormValid()} />
						}
						{ this.props.isModalVisible && this.props.modalVisible === 'inviteBackers' &&
							<ModalInviteBackers 
								data={this.state.data} 
								backers={this.state.backers} 
								allowedusers_accepted={this.state.allowedusers_accepted} 
								allowedusers_awaiting={this.state.allowedusers_awaiting} 
								dataID={this.state.data.project_id} 
								currentUser={this.props.currentUser} 
								usersList={this.props.usersList} 
								usersListFiltered={this.props.usersListFiltered}
								id={this.props.match.params.id} 
								actions={this.props.actions} 
								inviteBackersIsLoading={this.props.inviteBackersIsLoading} 
								messageInfo={() => this.messageInfo('Users added')} 
								messageInfoSolo={() => this.messageInfo('User added')} 
								type="inviteBackers" 
								backFormValid={() => this.backFormValid()} />
						}
						{ this.props.isModalVisible && this.props.modalVisible === 'alertDeleteProject' &&
							<ModalDeleteProject 
								id={this.props.match.params.id} 
								actions={this.props.actions} 
								deleteProjectIsLoading={this.props.deleteProjectIsLoading} 
								type="alertDeleteProject" 
								deleteProject={() => this.deleteProject()} 
								messageInfo={() => this.messageInfo('Project deleted')} 
								backFormValid={() => this.backFormValid()} />
						}
						<div className="projectDetail">
							<div className="header">
								{this.props.currentUser.email === this.state.data.creator_email && (this.state.backers && !areTransactionsFromCurrentYear(this.state.backers)) && !this.state.data.project_achieved_at &&
									<AlertLateProject 
										data={this.state.data} 
										backers={this.state.backers} 
										actions={this.props.actions}
										currentUser={this.props.currentUser}
										formRedirect={this.props.formRedirect}
										achieveProjectIsLoading={this.props.achieveProjectIsLoading}
										pictureStyle={pictureStyle}
										achieveProject={() => this.achieveProject()}
										moveProjectToCurrentYear={() => this.moveProjectToCurrentYear()} />
								}
								<div className="title">{this.state.data.title}</div>
								<div className="author">by {this.state.data.creator_name}</div>
								{ this.props.currentUser.email === this.state.data.creator_email &&
									<div className="edit">
										{!this.state.data.project_achieved_at &&
											<div className="button is-abort" onClick={() => this.displayModal('alertDeleteProject')}>
												<img src={Trash} alt="Trash" title="Trash" className="btnIcon" />
												Delete
											</div>
										}
										{!this.state.data.project_achieved_at &&
											<Link to={'/create/'+this.state.data.project_id} key={this.state.data.project_id}>
												<div className="button is-special">
													<img src={Edit} alt="Edit" title="Edit" className="btnIcon" />
													Edit
												</div>
											</Link>
										}
									</div>
								}
							</div>
							{ this.state.data.target ? 
								<div className="content">
									<ProjectInfos 
										current_amount={this.state.data.current_amount} 
										target={this.state.data.target} 
										privacy={this.state.data.privacy}
										achieved_at={this.state.data.project_achieved_at} />
									<div className="picture" style={pictureStyle}>
										{this.state.data.illustration ? <img src={this.state.data.illustration} alt={this.state.data.title} />
										: <div className="fallbackIllu"><img src={BackonLogoWhite} alt={this.state.data.title} /></div>}
									</div>
									{ this.state.data.description &&
										<div className="description">
											<Linkify>{this.state.data.description}</Linkify>
										</div>
									}
								</div>
								: <div className="content">
									<div className="loadingBloc"><Loader color="#000" /></div>
								</div>
							}
							<div className="informations">
								{ this.state.data.target ? 
									<div className={"infos-detail " + (this.props.currentUser.email === this.state.data.creator_email && "owner")}>
										<div className="currentAmount">€{this.state.data.current_amount === null ? '0' : this.state.data.current_amount}</div>
										<div className="target">out of €{this.state.data.target}</div>
										<div className={"progression " + (this.props.achieved_at && "achieved")}>
											<div className="progress" style={{'width':getProgress()}}></div>
										</div>
										<div className="counter"><strong>{this.state.current_backers}</strong> backer{this.state.current_backers === 1 || 0 ? "" : "s"}</div>
										{!this.state.data.project_achieved_at &&
											<div className="counter">
												End date: 
												<strong>
													{' ' + moment(this.state.data.project_end_at).fromNow()}
												</strong>
											</div>
										}
										{!this.state.data.project_achieved_at && (this.state.backers && areTransactionsFromCurrentYear(this.state.backers)) &&
											<div className="backProject">
												{this.state.hasUserBacked ?
													<div className="button is-abort" onClick={() => this.displayModal('alert')} >Cancel my backing</div>
												:
													<div className="button is-primary" onClick={() => this.displayModal('back')} >Make it pigger</div>
												}
											</div>
										}
										{ this.props.currentUser.email === this.state.data.creator_email && !this.state.data.project_achieved_at && this.state.current_backers > 0 &&
											<div className="achieveBloc" onClick={() => this.achieveProject()}>
												Sheep this project
											</div>
										}
										{this.state.data.project_achieved_at &&
											<div className="achieveBloc achieved">
												Project achieved
											</div>
										}
									</div>
								: <div className="infos-detail">
										<div className="loadingBloc"><Loader color="#000" /></div>
									</div>
								}
								{ ((this.state.backers && this.state.backers.length > 0) || (this.state.allowedusers_accepted && this.state.allowedusers_accepted.length > 0) || (this.state.allowedusers_awaiting && this.state.allowedusers_awaiting.length > 0) || (this.props.currentUser.email === this.state.data.creator_email && this.state.data.privacy === 1)) &&
									<div className="infos-detail backers">
										<div className="title">Backers</div>
										{this.props.currentUser.email === this.state.data.creator_email && this.state.data.privacy === 1 && !this.state.data.project_achieved_at &&
											<div className="inviteBackers"><div className="button is-primary" onClick={() => this.displayModal('inviteBackers')} >Invite some backers</div></div>
										}
										<div className="backersAvatars">
											{this.state.backers.map(createBackerAvatarItem)}
											{this.state.allowedusers_accepted &&
												this.state.allowedusers_accepted.map(createBackerAvatarItem)
											}
											<span className="awaiting">
												{this.state.allowedusers_awaiting &&
													this.state.allowedusers_awaiting.map(createBackerAvatarItem)
												}
											</span>
										</div>
										
									</div>
								}
							</div>
						</div>
					</div>
				}
				{this.props.deleteRedirect && (
		          <Redirect to={'/'}/>
		        )}
		        {this.props.refreshProject && 
		          window.location.reload()
		        }
			</div>
		);
	}
}

export default Project;



// WEBPACK FOOTER //
// ./src/components/Explore/Project.js